var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-date-picker',{staticClass:"form-control-solid",attrs:{"id":_vm.id,"value":_vm.localValue,"wrap":_vm.wrap,"config":_vm.options,"placeholder":_vm.placeholder,"state":_vm.state,"required":_vm.required},on:{"dp-change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }